import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import ReviewModal from './ReviewModal';
import { connect } from 'react-redux';
import { resetReviewForm } from '../actions/reviewActions';
import ReviewCards from './ReviewCards';

const Reviews = ({ product, resetReviewForm }: any) => {
  const [showReviewModal, setShowReviewModal] = useState(false);

  const handleReviewModal = () => {
    if (showReviewModal) {
      resetReviewForm();
    }
    setShowReviewModal(!showReviewModal);
  };

  return (
    <div className="py-3 ">
      <div>
        {product.reviews.length === 0 ? (
          <div className="d-inline">
            <i className="far fa-star" style={{ color: 'gold' }}></i>
            <i className="far fa-star" style={{ color: 'gold' }}></i>
            <i className="far fa-star" style={{ color: 'gold' }}></i>
            <i className="far fa-star" style={{ color: 'gold' }}></i>
            <i className="far fa-star " style={{ color: 'gold' }}></i>
          </div>
        ) : (
          <div className="d-inline">
            <i className="fas fa-star" style={{ color: 'gold' }}></i>
            <i className="fas fa-star" style={{ color: 'gold' }}></i>
            <i className="fas fa-star" style={{ color: 'gold' }}></i>
            <i className="fas fa-star" style={{ color: 'gold' }}></i>
            <i className="fas fa-star " style={{ color: 'gold' }}></i>
            <span> {product.reviews.length} Reviews</span>
          </div>
        )}

        <div className="d-inline float-right">
          <Button onClick={handleReviewModal} outline color="dark">
            <span>Write a Review</span>
          </Button>
        </div>

        {(!product.reviews || product.reviews.length === 0) && (
          <div className="py-3 mt-3">
            <h5 className="text-center">
              Be the first to{' '}
              <span
                onClick={handleReviewModal}
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  textDecorationThickness: 'from-font',
                }}
              >
                write a review
              </span>
            </h5>
          </div>
        )}
        {product.reviews.length !== 0 && <ReviewCards reviews={product.reviews} />}
      </div>

      {showReviewModal && (
        <Modal style={{ maxWidth: 700 }} isOpen={showReviewModal} toggle={handleReviewModal}>
          <ModalHeader style={{ border: 0 }} toggle={handleReviewModal}></ModalHeader>
          <ModalBody style={{ height: 500 }}>
            <ReviewModal product={product} />
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  reviews: state.reviews,
});

export default connect(mapStateToProps, { resetReviewForm })(Reviews);
